import memoize from "lodash.memoize";

import { typesFor } from "./types";

const createActionsFor = domain => {
  const types = typesFor(domain);

  const changeSort = field => ({
    type: types.CHANGE_SORT,
    payload: field,
    meta: { domain }
  });

  const setSort = (field, type = "asc") => ({
    type: types.SET_SORT,
    payload: { field, type },
    meta: { domain }
  });

  return { changeSort, setSort };
};

export const actionsFor = memoize(createActionsFor);
